import INavBar from "@src/component/INavBar";
import VerticalSpace from "@src/component/VerticalSpace";
import { goBack } from "@src/route";
import CommonService from "@src/service/commonService";
import { getUrlParams } from "@src/util";
import { Space, Toast } from "antd-mobile";
import { AddOutline } from "antd-mobile-icons";
import React, { useEffect, useState } from "react";
import "./index.scss";

interface DetailProps {
  imgUrls: { [key: string]: AfterUploadProps[] };
  [key: string]: any;
}

function ApplicationDetailEdit(props: any) {
  const {
    location: { search },
  } = props;
  const params = getUrlParams(search);
  const [detail, setDetail] = useState<DetailProps>({} as DetailProps);

  useEffect(() => {
    CommonService.getApplyDetail({ loaninginfoId: params.id }).then(
      (res: any) => {
        console.log(res);
        if (res) {
          setDetail(res);
        } else {
          setDetail({} as DetailProps);
        }
      }
    );
  }, []);

  const changeDetailImgs = (key: string, value: AfterUploadProps[]) => {
    if (value.length > 0) {
      setDetail((val: any) => {
        const { imgUrls } = val;
        return {
          ...val,
          imgUrls: { ...imgUrls, [key]: value },
        };
      });
    }
  };

  const submit = () => {
    const { imgUrls } = detail;
    const obj: any = { loaninginfoid: params.id };
    Object.keys(imgUrls).map((key) => {
      obj[key] = imgUrls[key].map((item) => item.id).join(",");
    });
    CommonService.applyCommit(obj).then(() => {
      Toast.show("操作成功！");
      goBack();
    });
  };

  return (
    <div className="apply-page">
      <INavBar title={`${params.name}的放款申请 `} />
      {detail.jujueReason && (
        <div className="reason">
          <span>
            {params.status === "3" && "已驳货:驳回"}
            {params.status === "4" && "已拒绝:拒绝"}
            原因：
          </span>
          {detail.jujueReason}
        </div>
      )}

      <div className="wrapper">
        <VerticalSpace size={16}>
          <ImageUpload
            labelText="购车合同"
            remark={['zsmoto','emo'].includes(params.source) ? "若选择分期盗抢保障，无需上传，请客户通过短信签署。":''}
            dataId={params.id}
            onChange={(v) => changeDetailImgs("carpurcontract", v)}
            value={detail?.imgUrls?.carpurcontract}
          />
          <ImageUpload
            required
            labelText="购车发票"
            remark={['zsmoto','emo'].includes(params.source) ?"若选择分期盗抢保障，请等待专员联系后开票。":''}
            dataId={params.id}
            limit={1}
            onChange={(v) => changeDetailImgs("carpurinvoice", v)}
            value={detail?.imgUrls?.carpurinvoice}
          />
          {/* <ImageUpload
            required
            labelText="驾驶证正本"
            dataId={params.id}
            limit={1}
            onChange={(v) => changeDetailImgs('driverlicoriginal', v)}
            value={detail?.imgUrls?.driverlicoriginal}
          />
          <ImageUpload
            required
            labelText="驾驶证副本"
            onChange={(v) => changeDetailImgs('driverliccopy', v)}
            value={detail?.imgUrls?.driverliccopy}
            dataId={params.id}
            limit={1}
          /> */}
          {params.source == "cfmoto" && (
            <ImageUpload
              required
              labelText="首付款支付凭证"
              onChange={(v) => changeDetailImgs("firstPaidProof", v)}
              value={detail?.imgUrls?.firstPaidProof}
              dataId={params.id}
              limit={20}
            />
          )}
          {/* <ImageUpload
            labelText="行驶证"
            onChange={(v) => changeDetailImgs('carlic', v)}
            value={detail?.imgUrls?.carlic}
            dataId={params.id}
          />
          <ImageUpload
            labelText="登记证"
            onChange={(v) => changeDetailImgs('carreglic', v)}
            value={detail?.imgUrls?.carreglic}
            dataId={params.id}
          /> */}
          <ImageUpload
            labelText="保证金付款凭证"
            onChange={(v) => changeDetailImgs("earnestmoneypaidproof", v)}
            value={detail?.imgUrls?.earnestmoneypaidproof}
            dataId={params.id}
            limit={1}
          />
          <ImageUpload
            labelText="手续费付款凭证"
            onChange={(v) => changeDetailImgs("commissionpaidproof", v)}
            value={detail?.imgUrls?.commissionpaidproof}
            dataId={params.id}
            limit={20}
          />
          {/* <ImageUpload
            labelText="抵押代办费付款凭证"
            onChange={(v) =>
              changeDetailImgs('mortgageagencyfeepaymentvoucher', v)
            }
            value={detail?.imgUrls?.mortgageagencyfeepaymentvoucher}
            dataId={params.id}
            limit={1}
          /> */}
          <ImageUpload
            labelText="盗抢保障订单截图凭证"
            remark={['zsmoto'].includes(params.source) ?"若选择分期盗抢保障，无需上传，将由后台下单":''}
            onChange={(v) => changeDetailImgs("securityservicepaidproof", v)}
            value={detail?.imgUrls?.securityservicepaidproof}
            dataId={params.id}
          />
          {/* <ImageUpload
            labelText="骑行意外险付款截图"
            onChange={(v) =>
              changeDetailImgs("rideaccidentservicepaidproof", v)
            }
            value={detail?.imgUrls?.rideaccidentservicepaidproof}
            dataId={params.id}
            limit={1}
          /> */}
          <ImageUpload
            required
            labelText="人车合影照"
            remark="合影中车辆为用户最终成交车辆"
            onChange={(v) => changeDetailImgs("peopleAndCarsProof", v)}
            value={detail?.imgUrls?.peopleAndCarsProof}
            dataId={params.id}
            limit={1}
          />
          <ImageUpload
            required
            labelText="发动机照"
            remark="请确保发动机号清晰可辨识、发动机照与发票上信息一致"
            onChange={(v) => changeDetailImgs("engineProof", v)}
            value={detail?.imgUrls?.engineProof}
            dataId={params.id}
            limit={1}
          />
          <ImageUpload
            required
            labelText="车架照"
            remark="请确保车架号清晰可辨识，车架照与发票上信息一致"
            onChange={(v) => changeDetailImgs("carframeProof", v)}
            value={detail?.imgUrls?.carframeProof}
            dataId={params.id}
            limit={1}
          />
          <ImageUpload
            labelText="其他"
            onChange={(v) =>
              changeDetailImgs("personalaccidentservicepaidproof", v)
            }
            value={detail?.imgUrls?.personalaccidentservicepaidproof}
            dataId={params.id}
            limit={15}
          />
        </VerticalSpace>
      </div>
      <div className="btn" onClick={submit}>
        确认并提交审核
      </div>
    </div>
  );
}

interface AfterUploadProps {
  id: number;
  osskey: string;
  osskeySmall: string;
}
interface ImageUploadProps {
  required?: boolean;
  onChange?: (fileList: AfterUploadProps[]) => void;
  labelText: string;
  dataId: string;
  limit?: number;
  value?: AfterUploadProps[];
  remark?: string;
}
function ImageUpload({
  required = false,
  onChange,
  labelText,
  dataId,
  limit = 100,
  value,
  remark,
}: ImageUploadProps) {
  const [fileList, setFileList] = useState<AfterUploadProps[]>([]);

  useEffect(() => {
    if (value && value.length > 0) {
      setFileList(value);
    }
  }, [value]);

  const fileUpload = (e: any) => {
    const { files } = e.target;
    const uploadFile = files[0];
    CommonService.uploadImage({ loanId: dataId, ruleimg: uploadFile }).then(
      ({ data }: any) => {
        setFileList((val) => {
          const temp = [...val, data];
          onChange?.(temp);
          return temp;
        });
      }
    );
  };

  const currentFileUpload = (e: any, index: number) => {
    const { files } = e.target;
    const uploadFile = files[0];
    CommonService.uploadImage({ loanId: dataId, ruleimg: uploadFile }).then(
      ({ data }: any) => {
        setFileList((val) => {
          const temp = [...val];
          temp.splice(index, 1, data);
          onChange?.(temp);
          return temp;
        });
      }
    );
  };
  return (
    <div className="upload-page">
      <Space align="center" style={{ "--gap": "2px" }}>
        {required && <span className="required">*</span>}
        <span className="label-text">{labelText}：</span>
      </Space>
      {remark && <span className="label-remark">{remark}</span>}
      <div className="img-box">
        <Space style={{ "--gap": "12px" }} align="center" wrap>
          {fileList.length > 0 &&
            fileList.map((item, index) => (
              <div key={item.id}>
                <label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => currentFileUpload(e, index)}
                  />
                  <img src={item.osskeySmall} alt="" />
                </label>
              </div>
            ))}
          {fileList.length < limit && (
            <label>
              <input type="file" accept="image/*" onChange={fileUpload} />
              <AddOutline style={{ fontSize: 50, color: "#8A8A8A" }} />
            </label>
          )}
        </Space>
      </div>
    </div>
  );
}
export default ApplicationDetailEdit;
